var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("EnterprieSidebarMenu", {
            attrs: {
              show_menu: true,
              show_back_button: false,
              back_link: "managerReports"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper padding-left-165" }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 p-0 pl-2" }, [
                  _c("h3", { staticClass: "heading text-uppercase mb-3" }, [
                    _vm._v(_vm._s(_vm.accountItems.account_name))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 pr-3 pr-xl-5" }, [
                  _vm.menteeCountLoading == true
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row justify-content-between custom-pl-15 pb-4"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col pl-0 pr-2" },
                            [
                              _c("PuSkeleton", {
                                attrs: { height: "150px", count: 1 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col pl-4" },
                            [
                              _c("PuSkeleton", {
                                attrs: { height: "150px", count: 1 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col pl-4 pr-1" },
                            [
                              _c("PuSkeleton", {
                                attrs: { height: "150px", count: 1 }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.menteeCountLoading == false
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row justify-content-between custom-pl-15 mb-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col pl-0 pr-xl-4 pr-lg-2 cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.goToLocation()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "shadow p-3 information_box" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "information_box_title" },
                                    [_vm._v("Locations")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h3" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.accountItems.totalMappedAccounts
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.accountItems.previousYearAccountCount >
                                    0 &&
                                  _vm.accountItems.previousYearAccountCount <
                                    _vm.accountItems.currentYearAccountCount
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "small px-2 py-1 information_box_text_up"
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "mr-1 stats_icon",
                                            attrs: {
                                              src: require("@/assets/manager/up_tick_icon.png")
                                            }
                                          }),
                                          _vm._v(
                                            "\n                    Up " +
                                              _vm._s(
                                                parseInt(
                                                  _vm.accountItems
                                                    .currentYearAccountCount -
                                                    _vm.accountItems
                                                      .previousYearAccountCount
                                                )
                                              ) +
                                              " this year"
                                          )
                                        ]
                                      )
                                    : _vm.accountItems
                                        .previousYearAccountCount > 0 &&
                                      _vm.accountItems
                                        .previousYearAccountCount >
                                        _vm.accountItems.currentYearAccountCount
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "small px-2 py-1 information_box_text_down"
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "mr-1 stats_icon",
                                            attrs: {
                                              src: require("@/assets/manager/down_tick_icon.png")
                                            }
                                          }),
                                          _vm._v(
                                            "\n                    Down " +
                                              _vm._s(
                                                parseInt(
                                                  _vm.accountItems
                                                    .previousYearAccountCount -
                                                    _vm.accountItems
                                                      .currentYearAccountCount
                                                )
                                              ) +
                                              " this year"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "small px-2 py-1" },
                                        [_vm._v(" ")]
                                      )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col px-xl-4 px-lg-2 cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.goToMenteeLists()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "shadow p-3 information_box" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "information_box_title" },
                                    [_vm._v("Mentees")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h3" }, [
                                    _vm._v(
                                      _vm._s(_vm.accountItems.totalMenteesCount)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.accountItems.previousYearMenteeCount >
                                    0 &&
                                  _vm.accountItems.previousYearMenteeCount <
                                    _vm.accountItems.currentYearMenteeCount
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "small px-2 py-1 information_box_text_up"
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "mr-1 stats_icon",
                                            attrs: {
                                              src: require("@/assets/manager/up_tick_icon.png")
                                            }
                                          }),
                                          _vm._v(
                                            "\n                    Up " +
                                              _vm._s(
                                                parseInt(
                                                  _vm.accountItems
                                                    .currentYearMenteeCount -
                                                    _vm.accountItems
                                                      .previousYearMenteeCount
                                                )
                                              ) +
                                              " this year"
                                          )
                                        ]
                                      )
                                    : _vm.accountItems.previousYearMenteeCount >
                                        0 &&
                                      _vm.accountItems.previousYearMenteeCount >
                                        _vm.accountItems.currentYearMenteeCount
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "small px-2 py-1 information_box_text_down"
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "mr-1 stats_icon",
                                            attrs: {
                                              src: require("@/assets/manager/down_tick_icon.png")
                                            }
                                          }),
                                          _vm._v(
                                            "\n                    Down " +
                                              _vm._s(
                                                parseInt(
                                                  _vm.accountItems
                                                    .previousYearMenteeCount -
                                                    _vm.accountItems
                                                      .currentYearMenteeCount
                                                )
                                              ) +
                                              " this year"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "small px-2 py-1" },
                                        [_vm._v(" ")]
                                      )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col pl-xl-4 pl-lg-2 pr-0 cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.goToCompetencyReport()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "shadow p-3 information_box" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "information_box_title" },
                                    [_vm._v("Competencies")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h3" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.accountItems
                                          .currentWeekCompetencyCount
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.accountItems.previousWeekCompetencyCount <
                                  _vm.accountItems.currentWeekCompetencyCount
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "small px-2 py-1 information_box_text_up"
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "mr-1 stats_icon",
                                            attrs: {
                                              src: require("@/assets/manager/up_tick_icon.png")
                                            }
                                          }),
                                          _vm._v(
                                            "\n                    Up " +
                                              _vm._s(
                                                parseInt(
                                                  _vm.accountItems
                                                    .currentWeekCompetencyCount -
                                                    _vm.accountItems
                                                      .previousWeekCompetencyCount
                                                )
                                              ) +
                                              " this week"
                                          )
                                        ]
                                      )
                                    : _vm.accountItems
                                        .previousWeekCompetencyCount >
                                      _vm.accountItems
                                        .currentWeekCompetencyCount
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "small px-2 py-1 information_box_text_down"
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "mr-1 stats_icon",
                                            attrs: {
                                              src: require("@/assets/manager/down_tick_icon.png")
                                            }
                                          }),
                                          _vm._v(
                                            "\n                    Down " +
                                              _vm._s(
                                                parseInt(
                                                  _vm.accountItems
                                                    .previousWeekCompetencyCount -
                                                    _vm.accountItems
                                                      .currentWeekCompetencyCount
                                                )
                                              ) +
                                              " this week"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "small px-2 py-1" },
                                        [_vm._v(" ")]
                                      )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 pr-0 mt-4" }, [
                      _c("div", { staticClass: "shadow rounded" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-row bd-highlight pt-3 pr-2"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-5 pr-0 h5 d-inline mr-2 font-weight-bold text-uppercase"
                              },
                              [_vm._v("Earned Competencies")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-4 ea-filter-dropdown text-align-right float-left"
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.select_earned_location,
                                        expression: "select_earned_location"
                                      }
                                    ],
                                    staticClass:
                                      "custom-select custom-select-sm",
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.select_earned_location = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                        function($event) {
                                          return _vm.onChangeLocationEarnedCompetencies(
                                            $event
                                          )
                                        }
                                      ]
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("All Locations")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.report_all_locations, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: item.id }
                                        },
                                        [_vm._v(_vm._s(item.company_name))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-3 pr-2 ea-filter-dropdown text-align-right float-right pl-0"
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass:
                                      "custom-select custom-select-sm",
                                    on: {
                                      change: function($event) {
                                        return _vm.onChangeMonthEarnedCompetencies(
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "6" } }, [
                                      _vm._v("6 Months")
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "9" } }, [
                                      _vm._v("9 Months")
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "12" } }, [
                                      _vm._v("12 Months")
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mychart",
                            attrs: { id: "myChartDiv2" }
                          },
                          [
                            _c("canvas", {
                              attrs: {
                                id: "myChart2",
                                width: "400",
                                height: _vm.height
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row ea-row mt-5" }, [
                    _c("div", { staticClass: "col-12 pr-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "shadow rounded pr-2 pl-3 py-1 min-height-330"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex flex-row bd-highlight pt-3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-9 h5 d-inline mr-2 pl-0 font-weight-bold text-uppercase"
                                },
                                [_vm._v("Competency Comparison")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-3 pr-2 ea-filter-dropdown"
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.competency_comparison,
                                          expression: "competency_comparison"
                                        }
                                      ],
                                      staticClass:
                                        "custom-select custom-select-sm",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.competency_comparison = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          _vm.getCompetencyComparison
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "60" } }, [
                                        _vm._v("60 Days")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "90" } }, [
                                        _vm._v("90 Days")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "180" } },
                                        [_vm._v("6 Months")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "365" } },
                                        [_vm._v("1 Year")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {}, [
                            _vm.comp_loading == false
                              ? _c("div", { staticClass: "row mt-3" }, [
                                  _c("div", { staticClass: "col-1" }, [
                                    _vm._v("#")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-5" }, [
                                    _vm._v("Location")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-3 text-center" },
                                    [_vm._v("Reps Recorded")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-3 text-center" },
                                    [_vm._v("Competencies Earned")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            _vm.comp_loading == true
                              ? _c(
                                  "div",
                                  { staticClass: "text-center pt-4" },
                                  _vm._l(5, function(option) {
                                    return _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-1" },
                                        [
                                          _c("PuSkeleton", {
                                            attrs: { count: 1 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-5 padding-l-10" },
                                        [
                                          _c("PuSkeleton", {
                                            attrs: { count: 1 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 padding-l-10" },
                                        [
                                          _c("PuSkeleton", {
                                            attrs: { count: 1 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 padding-l-10" },
                                        [
                                          _c("PuSkeleton", {
                                            attrs: { count: 1 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._m(0, true)
                                    ])
                                  }),
                                  0
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.competencyComparisonCount > 0
                              ? _c(
                                  "div",
                                  { staticClass: "col-12 p-0 mt-4" },
                                  _vm._l(
                                    _vm.accountItems.competencyComparison,
                                    function(item, index) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "row" },
                                        [
                                          index == 0 &&
                                          (item.reps_recorded > 0 ||
                                            item.competencies_earned > 0) &&
                                          !_vm.isReadOnly
                                            ? _c(
                                                "div",
                                                { staticClass: "col-1 pl-0" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("@/assets/enterprise/Required_Gold_Batch_image_45X45.png")
                                                    }
                                                  })
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "col-1" },
                                                [_vm._v(_vm._s(index + 1))]
                                              ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "col-5" }, [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "ea-quick-link cursor-pointer font-color-00acee",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openSidebar(
                                                      item.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.org_name) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-3  text-center"
                                            },
                                            [_vm._v(_vm._s(item.reps_recorded))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-3 text-center"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.competencies_earned)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "clearfix" })
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _c(
                                  "div",
                                  { staticClass: "text-red text-center m-4" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getNoRecordText(
                                          _vm.competencyComparisonCount
                                        )
                                      )
                                    )
                                  ]
                                )
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-6 pl-4 pl-xl-4 pr-3 pr-xl-5 mb-5" },
                  [
                    _c("div", { staticClass: "col-12 mb-3 p-0" }, [
                      _c("div", { staticClass: "shadow rounded px-2 py-1" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "information_box_title pt-2 mt-1 mb-0 pl-2"
                          },
                          [_vm._v("Quick Access")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row justify-content-center mb-2" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "text-muted",
                                attrs: { to: { name: "locations" } }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "report-panel rounded text-center p-1 text-muted"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "report-icon1 ",
                                      attrs: {
                                        height: "25px",
                                        width: "14px",
                                        src: require("@/assets/manager/Enterprise_Quick_Access_Locations_Icons.png")
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mb-0 small font-color-002f42"
                                      },
                                      [_vm._v("Locations")]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "text-muted",
                                attrs: {
                                  to:
                                    "/enterprise-admin/competency-report-overview/All"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "report-panel rounded text-center p-1 text-muted"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "report-icon report-badge",
                                      attrs: {
                                        src: require("@/assets/manager/competency_report_icon.png")
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mb-0 small font-color-002f42"
                                      },
                                      [_vm._v("Competency")]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "text-muted",
                                attrs: {
                                  to: { name: "enterpriseadminusagereport" }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "report-panel rounded text-center p-1 text-muted mr-0"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "report-icon",
                                      attrs: {
                                        src: require("@/assets/manager/usage_report_icon.png")
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mb-0 small font-color-002f42"
                                      },
                                      [_vm._v("Usage")]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "text-muted",
                                attrs: {
                                  to: {
                                    name:
                                      "EnterprisePathwayProgressPathwayLists"
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "report-panel rounded text-center p-1 text-muted"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "report-icon",
                                      attrs: {
                                        src: require("@/assets/manager/Mentor Mentee Progress Report Icon.png")
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mb-0 small font-color-002f42"
                                      },
                                      [_vm._v("Progress")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 mt-4" }, [
                        _c("div", { staticClass: "shadow rounded" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-row bd-highlight pt-3 pr-2"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-5 pr-0 h5 d-inline mr-2 font-weight-bold text-uppercase"
                                },
                                [_vm._v("Activity Over Time")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-4 ea-filter-dropdown text-align-right float-left"
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.select_activity_location,
                                          expression: "select_activity_location"
                                        }
                                      ],
                                      staticClass:
                                        "custom-select custom-select-sm",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.select_activity_location = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          function($event) {
                                            return _vm.onChangeLocationActivityOverTime(
                                              $event
                                            )
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("All Locations")
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.report_all_locations, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: { value: item.id }
                                          },
                                          [_vm._v(_vm._s(item.company_name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-3 pr-2 ea-filter-dropdown text-align-right float-right pl-0"
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      staticClass:
                                        "custom-select custom-select-sm",
                                      on: {
                                        change: function($event) {
                                          return _vm.onChangeMonthActivityOverTime(
                                            $event
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "6" } }, [
                                        _vm._v("6 Months")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "9" } }, [
                                        _vm._v("9 Months")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "12" } }, [
                                        _vm._v("12 Months")
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mychart",
                              attrs: { id: "myChartDiv" }
                            },
                            [
                              _c("canvas", {
                                attrs: {
                                  id: "myChart",
                                  width: "400",
                                  height: _vm.height
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 p-0 notification-wrapper" },
                      [_c("DashboardNotifications")],
                      1
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("EnterpriseAdminOverlaySidebar", {
        ref: "location_sidebar",
        attrs: { isModalVisible: _vm.isModalVisible, readOnly: _vm.isReadOnly },
        on: { close: _vm.closeSidebar }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 p-0" }, [
      _c("div", { staticClass: "custom_hr" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44fafd12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44fafd12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/enterprise_admin_dashboard.vue
// module id = null
// module chunks = 